module.exports = __webpack_public_path__ + "media/books/ArtBooks-Testimonial2-074d6769.png";